import * as actionTypes from "./../../Constants/categoryActionTypes";
import API from "./../../Constants/categories/API"
import * as categoryServices from "../../services/categories/index"

export const categories = (categoryData) => ({
    type: actionTypes.FETCH_ALL_CATEGORIES,
    payload: { categoryData: categoryData }
})

export function fetchAllCategories (firmId) {
    return async dispatch => {
        const request = await categoryServices.req.getAllCategories(API.getAllCategories, firmId)
        return dispatch(categories(request.filter(elem => elem.category_id !== 7)));

    };
}
